var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16H34C34.5304 16 35.0391 16.2107 35.4142 16.5858C35.7893 16.9609 36 17.4696 36 18V38C36 38.5304 35.7893 39.0391 35.4142 39.4142C35.0391 39.7893 34.5304 40 34 40H2C1.46957 40 0.960859 39.7893 0.585786 39.4142C0.210714 39.0391 0 38.5304 0 38V18C0 17.4696 0.210714 16.9609 0.585786 16.5858C0.960859 16.2107 1.46957 16 2 16H4V14C4 12.1615 4.36212 10.341 5.06569 8.64243C5.76925 6.94387 6.80048 5.40053 8.1005 4.1005C9.40053 2.80048 10.9439 1.76925 12.6424 1.06569C14.341 0.362121 16.1615 0 18 0C19.8385 0 21.659 0.362121 23.3576 1.06569C25.0561 1.76925 26.5995 2.80048 27.8995 4.1005C29.1995 5.40053 30.2307 6.94387 30.9343 8.64243C31.6379 10.341 32 12.1615 32 14V16ZM4 20V36H32V20H4ZM16 24H20V32H16V24ZM28 16V14C28 11.3478 26.9464 8.8043 25.0711 6.92893C23.1957 5.05357 20.6522 4 18 4C15.3478 4 12.8043 5.05357 10.9289 6.92893C9.05357 8.8043 8 11.3478 8 14V16H28Z",
    fill: "#20E083"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLock);
export default __webpack_public_path__ + "static/media/green-lock.57baa945206faa74ab02c6e99e1d69b2.svg";
export { ForwardRef as ReactComponent };